import React, { ChangeEvent, Component } from "react";
import { connect } from "react-redux";
import {
  WithStyles,
  withStyles,
  Button,
  Grid,
  Typography,
  Checkbox,
  FormControlLabel,
  Radio,
  createStyles,
  Theme,
  Menu,
  MenuItem,
  Link,
  ClickAwayListener,
  RadioGroup,
  Switch,
  InputLabel,
  TextField,
} from "@material-ui/core";
import { Error } from "@material-ui/icons";

import { MyPATDialog, MyPATIconButton, MyPATSelect, MyPATTextField } from "../../common";

import { bindActionCreators } from "redux";
import * as XLSX from "xlsx";

import {
  getCourseList,
} from "../../userManagement/actions/userActions";
import courseManagementServices from "../service/courseManagementServices";
import * as courseManagementActions from "../actions/courseManagementActions";
import cx from "classnames";
import moment from "moment";

import TimeInput from 'material-ui-time-picker';
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import _ from "lodash";
import { CloseOutlined as CloseIcon } from "@material-ui/icons";
import DropZone from "../../common/DropZone";
import MyPATUploader from "../../common/MyPATUploader";
import { Goal } from "../types/interfaces/Goal";
import { ExistingScheduledTest,contentType,fetchContentBody } from "../types/interfaces/ExistingScheduledTest";
import { getActiveGoals } from "../actions/courseManagementActions";
import { createErrorSheet } from "../helpers/helpers";
import {Package,Version} from '../types/interfaces/CourseBasicDetails';
import { off } from "process";
import MyPATCalendar from "../../common/MyPATCalendar";
import { debounce } from "../../../utils";


const styles = (theme: Theme) =>
  createStyles({
    menuItem: {
      borderStyle: "solid",
      borderBottomWidth: 1,
      borderColor: theme.palette.grey[300],
      padding: 0,
      height: "auto",
      minWidth: "170px",
      "&:last-child": {
        borderBottomWidth: 0,
      },
      "& a": {
        paddingTop: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
        paddingRight: theme.spacing.unit * 2,
        paddingLeft: theme.spacing.unit * 2,
        width: "100%",
      },
      "& img, & p": {
        display: "inline-block",
        verticalAlign: "middle",
        fontSize: 14,
        lineHeight: "19px",
        color: "#333333",
      },
    },
    bulkTitle: {
      fontSize: 20,
      fontWeight: 600,
      margin: 0,
    },
    orDevider: {
      position: "relative",
      marginBottom: 50,
      alignItems: "center",
      marginTop: 10,
      "&::before": {
        top: "50%",
        left: "47%",
        content: '"OR"',
        position: "absolute",
        width: "30px",
        height: "30px",
        backgroundColor: "#e5edf5",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1,
        transform: "translate(0%, -50%)",
        borderRadius: "50%",
        fontWeight: 600,
        fontSize: 12,
        color: "#666",
      },
      "&::after": {
        left: "50%",
        content: '" "',
        position: "absolute",
        border: "1px solid #e4e4e4",
        height: "100%",
      },
      "& button": {
        margin: "10px 0",
      },
    },
    paddingLeft: {
      paddingLeft: 40,
      textAlign: "center",
    },

    paddingRight: {
      paddingRight: 40,
    },
    disabled: {
      opacity: 0.5,
      cursor: "default",
      pointerEvents: "none",
    },
    optionContainer: {
      marginTop: 10,
      position: "relative",
      "& input": {
        border: "1px solid #DFDFDF",
        width: "100%",
        padding: "10px",
        borderRadius: 4,
        background: 'none',
        height: 45,
        lineHeight: '45px',
        cursor: 'pointer',
        paddingRight: 70,
        textOverflow: 'ellipsis',
        fontSize: 14,
        '&:focus-visible':{
          outline: '2px solid #1d7dea',
        }
      },
    },
    optionlistContainer: {
      position: "relative",
      "&:hover": {
        cursor: "pointer",
      },
      "&::after": {
        top: "5px",
        right: "18px",
        border: "solid rgb(0 0 0 / 0%)",
        height: 0,
        content: '" "',
        zIndex: 999,
        position: "absolute",
        transform: "rotate(226deg)",
        boxShadow: "1px 1px 1px #DFDFDF",
        background: "rgb(255 255 255)",
        borderColor: "rgb(194 225 245 / 0%)",
        borderWidth: 9,
        borderBottomColor: "rgb(255 255 255)",
      },
    },
    optionList: {
      width: "100%",
      border: "1px solid #DFDFDF",
      display: "block",
      position: "absolute",
      backgroundColor: "#fff",
      top: "13px",
      borderRadius: "7px",
      maxHeight: 250,
      overflowX: "hidden",
      overflowY: "auto",
      zIndex: 2,
      "& input": {
        marginTop: 15,
        paddingLeft: 40,
      },
      "& span": {
        display: "block",
        padding: "1px 0px 2px 10px",
        cursor: "pointer",
      },

      // top: "-16px",
      // right: "15px",
      // width: 0,
      // height: 0,
      // content: '" "',
      // position: "absolute",
      // marginLeft: "-20px",
      // borderLeft: "10px solid transparent",
      // borderRight: "10px solid transparent",
      // borderBottom: "15px solid #dadada",
      // borderTopLeftRadius: "20px",
      // borderTopRightRadius: "0px",
      // }
    },
    optionListEdit: {
      "& span": {
        padding: "10px 15px",
        borderBottom: "1px solid #eee",
      },
    },
    searchContainer: {
      position: "sticky",
      top: 0,
      zIndex: 1,
      backgroundColor: '#fff',
      paddingBottom: 15,
      borderBottom: '1px solid #e6e6e6',
      marginBottom: 10,
      paddingLeft: 15,
      paddingRight: 15,
      "& img": {
        left: 29,
        position: "absolute",
        top: 29,
      },
    },
    padding2x: {
      padding: "10px 0",
    },
    courseTitle: {
      fontSize: 16,
      fontWeight: 600,
    },
    plusCourse: {
      position: "relative",
      "& span": {
        position: "absolute",
        right: 0,
        top: 5,
        color: "#1d7dea",
        width: 35,
        height: 35,
        backgroundColor: "#e8f2fd",
        borderRadius: "50%",
        fontSize: 12,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontWeight: "bold",
        marginRight: 35,
      },
    },
    fileInfo: {
      fontSize: 12,
      lineHeight: "16px",
      color: "#999",
      display: "block",
      fontWeight: "normal",
    },
    uploadPreview: {
      "&>:first-child": {
        justifyContent: "center",
        "&>:first-child": {
          "&>:first-child": {
            margin: "16px 0",
          },
        },
      },
    },
    textCenter: {
      textAlign: "center",
    },
    noBorder: {
      borderBottom: 0,
    },
    iconRoot: {
      fill: theme.palette.text.secondary,
      // opacity: 0.5,
      margin: 0,
      width: "2rem",
      height: "2rem",
    },
    buttonCloseCont: {
      position: "relative",
      height: 20,
      "& button": {
        position: "absolute",
        right: "-15px",
        top: "-35px",
        border: "none",
      },
    },
    arrowIcon: {
      position: "absolute",
      right: 10,
      top: 12,
      transform: "scale(1.3)",
      zIndex: 1,
      width: 20,
      height: 20,
      backgroundColor: "#fff",
      cursor: 'pointer',
      "& img": {
        // opacity: 0.3,
        width: 15,
      },
    },
    testRadioGroup: {
      width: "100%",
      display: "inline-block",
      "& $label": {
        "&>:nth-child(2)": {
          fontSize: 16,
          fontWeight: 400,
          color: "#333",
        },
      },
    },
    customSelect:{
      marginBottom: 10,
      '&>div:nth-of-type(1)':{
        width: '100%',
        marginTop: 10,
        '& select':{
          height: 45,
        }
      }
    },
    customInput:{
      position: 'relative',
      '&>div:nth-of-type(1)':{
        marginTop: 10,
        marginBottom: 0,
        padding: 0,
        width: '100%',
        '&>div:nth-of-type(1)':{
          padding: 0,
          '&>div:nth-of-type(1)':{
            padding: 0,
          }
        }
      },
      '& input':{
        border: "1px solid #DFDFDF",
        width: "100%",
        padding: "10px",
        borderRadius: 4,
        background: 'none',
        height: 45,
        lineHeight: '45px',
        // cursor: 'pointer',
        paddingRight: 70,
        textOverflow: 'ellipsis',
        fontSize: 14,
        boxSizing: 'border-box'
      },
      '& fieldset':{
        // position: 'initial',
        border: 'none',
      },
      '&>span':{
        position: "absolute",
        right: 15,
        top: 52,
        color: "#999",
        zIndex: 1,
      }
    },
    textAreaEdit:{
      padding: 0,
      '& input':{
        border: 'none',
        padding: '0 10px',
      }
    },
    calenderEdit:{
      padding: 0,
      '& input':{
        border: "1px solid #eee",
        padding: "0 15px",
        marginTop: "10px",
        height: "44px",
        borderRadius: "5px"
      }
    },
    colorRed:{
      color: '#D9505D'
    },
    customTime:{
      marginTop:15,
      // marginBottom:15,
      '& input':{
        border: "1px solid #DFDFDF",
        borderRadius:4,
        height: '44px',
        padding: '0 15px',
        color: '#333',
        fontSize: 16,
        marginTop: 20,
        '&::placeholder':{
          color: "#999",
          fontWeight: 'normal',
          fontSize:14,
          opacity: 1,
        },
        '&:hover':{
          cursor: 'pointer',
        },
      },
      '&>:first-child':{
        width: '100%',
        '&::before':{
          borderBottom: '0 !important',
        },
        '&::hover':{
          borderBottom: 0,
        },
        '&::placeholder':{
          color: "#999",
          fontWeight: 'normal',
          fontSize:14,
          opacity: 1,
          fontFamily: '"Nunito", sans-serif',
        },
      },
    },
    customTimeEdit:{
      marginTop:15,
      // marginBottom:15,
      '& input':{
        marginTop: 25,
        lineHeight: '44px',
        height: 46,
        '&::placeholder':{
          color: "#999",
          fontWeight: 'normal',
          fontSize:14,
          opacity: 1,
        },
        '&:hover':{
          cursor: 'pointer',
        },
      },
      '&>:first-child':{
        width: '100%',
        '&::before':{
          borderBottom: '0 !important',
        },
        '&::hover':{
          borderBottom: 0,
        },
        '&::placeholder':{
          color: "#999",
          fontWeight: 'normal',
          fontSize:14,
          opacity: 1,
          fontFamily: '"Nunito", sans-serif',
        },
      },
    },
    switchContainer:{
      '& input':{
        width: 100,
      },
      '&>div:nth-of-type(1)':{
        margin: 0,
      }
    },
    formula:{
      '& span':{
        padding: 0,
        display: 'initial',
        border: 'none'
      }
    },
    plr15:{
      padding: '6px 15px',
      '& label':{
        alignItems: 'flex-start',
        marginLeft: 0,
      }
    },
    contentTitle:{
      marginTop: 8,
      paddingLeft: 11,
    }
  });

interface EditRemoveContentProps extends WithStyles<typeof styles> {
  classes: any;
  courseList: any[];
  setBulkImportTest: Function;
  fetchExistingScheduledTests: Function;
  openBulkImport: boolean;
  closeBulkImport: Function;
  redirectToBulkImport: Function;
  getActiveGoals: Function;
  goals: Goal[];
  fetchScheduleTests: Function;
  scheduledTests: ExistingScheduledTest[];
  getCourseList:(obj:any)=>void;
  fetchContentFromPackages:Function,
  isContentLoading:boolean,
  packagesContent:any []
}

interface EditRemoveContentState {
  openConfirmationPopup: boolean;
  openDeletePopup:boolean;
  actionType: string;
  filteredGoals: Goal[];
  showSingleGoalDropdown: boolean;
  selectedGoal: Goal | { [name: string]: string };
  isLoading: boolean;
  showTestDropdown: boolean;
  selectedTest: string[];
  filteredTestList: ExistingScheduledTest[];
  primaryTest:ExistingScheduledTest|undefined;
  disabledPrimaryDropDown:boolean;
  testCourseCount: number;
  scheduleIds: string[];
  inputTestId: string,
  showPackageDropdown:boolean,
  selectedPackage:string [],
  filteredPackageList:Package[],
  selectedContentType:contentType|any,
  selectedContent:any,
  selectedContentsForDelete:any [],
  filteredContents:any [],
  showSingleContentDropdown:boolean,
  selectedFields:string[],
  allFields:string [],
  showFieldsDropdown:boolean,
  isBonus:boolean;
  minimumProficency:any;
  formData:any
}
const zero24='000000000000000000000000';
enum selectedFieldsMap {
  title="Test Name",
  syllabus="Test Syllabus",
  startDate="Start Date & Time",
  endDate="End Date & Time",
  questionCount="Question Count",
  duration="Duration",
  maxAttempts="Max Attempt",
  revisionTime="Block Revision Time"
 }
class EditRemoveContent extends Component<
  EditRemoveContentProps,
  EditRemoveContentState
> {
  constructor(props: EditRemoveContentProps) {
    super(props);
    this.state = {
      openConfirmationPopup: false,
      openDeletePopup:false,
      actionType: "edit",
      filteredGoals: [],
      showSingleGoalDropdown: false,
      selectedGoal: { name: "" },
      isLoading: false,
      showTestDropdown: false,
      filteredTestList: [],
      selectedTest: [],
      primaryTest:undefined,
      disabledPrimaryDropDown:false,
      testCourseCount: 0,
      scheduleIds: [],
      inputTestId: '',
      showPackageDropdown:false,
      selectedPackage:[],
      filteredPackageList:[],
      selectedContentType:undefined,
      selectedContent:{},
      filteredContents:[],
      selectedContentsForDelete: [],
      showSingleContentDropdown:false,
      selectedFields:[],
      allFields:["Test Name","Test Syllabus","Start Date & Time",
                     "End Date & Time","Question Count","Duration",
                      "Max Attempt","Block Revision Time"],
      showFieldsDropdown:false,
      isBonus:false,
      minimumProficency:'',             
      formData:{}
    };
    this.openCourse = debounce(this.openCourse, 200);
    this.toggleGoalDropDown = debounce(this.toggleGoalDropDown, 200);
    this.handleChange=this.handleChange.bind(this);
  }

  componentDidMount() {}
  componentDidUpdate(
    prevProps: EditRemoveContentProps,
    prevState: EditRemoveContentState
  ) {
    if (this.state.selectedGoal !== prevState.selectedGoal && !_.isEmpty(this.state.selectedGoal._id)) {
      this.props.getCourseList({goals:this.state.selectedGoal._id,pagination:false,statusValue:'PUBLISHED,LIVE,PAST',statusType:'master'});
    }
    if(this.state.selectedContentType && this.state.selectedContentType!==prevState.selectedContentType){
      const{selectedGoal,selectedContentType,selectedPackage}=this.state;
      const{courseList}=this.props;
       const body:fetchContentBody={
         courseId:selectedGoal._id,
         contentType:selectedContentType,
         packages:courseList.reduce((acc:{id:string,sku:string}[],p)=>{ 
               if(selectedPackage.includes(p._id)){
                   acc=[...acc,{id:p._id,sku:p.sku}]
                }
              return acc;
              },[])
       }
        this.setState({selectedContent:{},selectedFields:[]});
        this.props.fetchContentFromPackages(body);
    }
    if(this.state.selectedContent!==prevState.selectedContent && this.state.selectedContentType==='scheduledTests'){
      const {selectedContent,allFields}=this.state;
       let newFileds=[...allFields];
    
       if(selectedContent.id && selectedContent.id!=zero24){
         newFileds=allFields.filter((f)=>f!=="Question Count"&&f!=="Duration"); 
       }
       this.setState({formData:{...selectedContent},allFields:newFileds});  
    } 
  }
  downloadCourseSheet = async () => {
    const { scheduleIds } = this.state;

    let payload = {
      scheduleTestIds: scheduleIds,
      isCount: false
    }
    let packageSkus =await courseManagementServices.fetchCourseDataListWithScheduleId(payload);
    packageSkus = packageSkus.packageSkus;
    const data:any[]=[];
    packageSkus.forEach((packageData:any)=>{
      const obj:any={};
      for(let key in packageData){
        if(key === "sku" || key === "reasons" || key === "status" || key === "mainTestCount" || key === "milestoneTestCount" ) {
          obj["sku".toUpperCase()] = packageData["sku"];
        }
      }
      data.push(obj);
    })
    if(data.length==packageSkus.length){
        createErrorSheet(data,'CourseSKUs.xlsx');
    }
  } 
  openConfirmationDialog = async () => {
    const { scheduledTests } = this.props;
    const { selectedTest } = this.state;
    let scheduleIds: any[] = scheduledTests.filter( (testData) => selectedTest.includes(testData._id));
    scheduleIds = scheduleIds.map((test) => test.scheduleID);
    let payload = {
      scheduleTestIds: scheduleIds,
      isCount: true
    }
    let testCourseCount =await courseManagementServices.fetchCourseDataListWithScheduleId(payload);
    testCourseCount = testCourseCount.count;
    this.setState({ openConfirmationPopup: true,testCourseCount, scheduleIds });
  }

  closeConfirmationDialog() {
    this.setState({ openConfirmationPopup: false });
  }
  resetPopup() {
    this.setState({
      scheduleIds: [],
      testCourseCount: 0,
      selectedTest: [],
      inputTestId: "",
      primaryTest: undefined,
      selectedGoal: {name:''},
      selectedFields: [],
      selectedPackage: [],
      filteredContents:[],
      filteredPackageList:[],
      selectedContentType: undefined,
      selectedContent: {},
      selectedContentsForDelete: [],
    });

  }

  handleRadio = () => {
    const { classes } = this.props;
    const { actionType } = this.state;
    return (
      <div className={classes.root}>
        <Grid container justify="space-between">
          <RadioGroup
            name="actionType"
            classes={{
              root: classes.testRadioGroup,
            }}
            className={classes.courseRadioGroup}
            onChange={(_: any, value: string) => {
              this.setState({ actionType: value } as any)
              this.resetPopup()
            }
            }
            value={actionType}
          >
            <FormControlLabel
              control={
                <Radio
                  color="primary"
                  classes={{ root: classes.testRadioRoot }}
                />
              }
              label={"Edit Content"}
              value={"edit"}
            />
            <FormControlLabel
              control={
                <Radio
                  color="primary"
                  classes={{ root: classes.testRadioRoot }}
                />
              }
              value={"delete"}
              label={"Remove Content"}
            />
          </RadioGroup>
        </Grid>
      </div>
    );
  };
  toggleGoalDropDown = (name:string) => {
    const { showSingleGoalDropdown,showPackageDropdown,showSingleContentDropdown,showFieldsDropdown } = this.state;
    const { goals,courseList,packagesContent } = this.props;
   if(name==="goal"){
      this.setState({
        showSingleGoalDropdown: !showSingleGoalDropdown,
        filteredGoals: [...goals],
      });
     }else if(name=="package"){
       this.setState((prevState) => ({
        ...prevState,
        showPackageDropdown: !prevState.showPackageDropdown,
        filteredPackageList: [...courseList],
      }));  
     }
     else if(name=="content"){
      this.setState({
        showSingleContentDropdown:!showSingleContentDropdown,
        filteredContents: [...packagesContent]
      });          
     }else if(name=="fields"){
       this.setState({
        showFieldsDropdown:!showFieldsDropdown
       })
     }
   };
  toggleTestDropdown = () => {
    const { showTestDropdown } = this.state;
    const { scheduledTests } = this.props;

    this.setState({
      showTestDropdown: !showTestDropdown,
      filteredTestList: [...scheduledTests],
    });
  };

  getFilteredGoals(event:any) {
    let {value,name}=event.target;
    const { goals,packagesContent } = this.props;
    const { isLoading } = this.state;
    let charterlength = name==='goal'?3:1;
    if(value.length>=charterlength){
    this.setState({ isLoading: true });
    this.setState((prevState) => {
      let suggestions: any = [];
      value = value.toString();
      value = value.replace(/[{()}]/g, '');
    value = value.replace(/\\|\//g,'')
      const arr=name==='goal'? goals:packagesContent;
      if (value.length > 0) {
        value = value.toLowerCase();
        for (let indx = 0; indx < arr.length; indx++) {
          let ug = arr[indx];
          if ((ug.name && ug.name.replace(/[{()}]/g, '').replace(/\\|\//g,'').toLocaleLowerCase().search(value) != -1)||(
            name==='content'&& (ug.contentId && ug.contentId.replace(/[{()}]/g, '').replace(/\\|\//g,'').toLocaleLowerCase().search(value) != -1)
          )) {  
            suggestions.push(ug);
          }
        }
      } else {
        suggestions = [...arr];
      }
      if(name=='goal' || name == 'content')
        return { filteredGoals: suggestions, isLoading: false };
      return { filteredContents: suggestions, isLoading: false, };
    });
  }else{
    this.setState((prevState) => {
      if(name=='goal')
      return { filteredGoals: goals, isLoading: false };
      return { filteredContents: packagesContent, isLoading: false };
   
    })
    }
  }

  getFilteredContent=(event:any)=>{
    let {value,name}=event.target;
    const {packagesContent } = this.props;
    const { isLoading } = this.state;
    if(value.length>1){
     this.setState({ isLoading: true });
    this.setState((prevState) => {
      let suggestions: any = [];
      value = value.toString();
      value = value.replace(/[{()}]/g, '');
    value = value.replace(/\\|\//g,'')
      const arr=packagesContent;
      if (value.length > 0) {
        value = value.toLowerCase();
        for (let indx = 0; indx < arr.length; indx++) {
          let ug = arr[indx];
          if ((ug.title && ug.title.replace(/[{()}]/g, '').replace(/\\|\//g,'').toLocaleLowerCase().search(value) != -1)||
          (ug.contentId && ug.contentId.replace(/[{()}]/g, '').replace(/\\|\//g,'').toLocaleLowerCase().search(value) != -1)
          ) {  
            suggestions.push(ug);
          }
        }
     
        return { filteredContents: suggestions, isLoading: false, };
      }
      
    });
  }else{
    return { filteredContents: packagesContent, isLoading: false, };
  }
  }

  getTestSuggestions(value: string) {
    const { scheduledTests } = this.props;
    value = value.toString();
    value = value.replace(/[{()}]/g, '');
    value = value.replace(/\\|\//g,'')
    this.setState((prevState) => {
      let suggestions: any = [];
      if (value.length > 0) {
        value = value.toLowerCase();

        for (let indx = 0; indx < scheduledTests.length; indx++) {
          let ug = scheduledTests[indx];
          if (
            ug.displayName &&
            ug.displayName.replace(/[{()}]/g, '').replace(/\\|\//g,'').toLocaleLowerCase().search(value) != -1
          ) {
            suggestions.push(ug);
          }
        }
      } else {
        suggestions = [...scheduledTests];
      }
      return { filteredTestList: suggestions };
    });
  }
  // getScheduledTests() {
  //   const { selectedGoal } = this.state;
  //   console.log({ selectedGoal });
  //   this.setState({selectedTest:[],filteredTestList:[],primaryTest:undefined});
  //   const params = {
  //     itemType: "scheduledTests",
  //     id: selectedGoal._id,
  //   };
  //   const queryParams = {
  //     actionType: this.state.actionType,
  //   };
  //   this.props.fetchScheduleTests({ params, queryParams });
  // }

  DeleteProcess=async ()=>{
    const { selectedGoal, filteredPackageList,selectedContent,selectedContentType,selectedPackage,
      selectedContentsForDelete,filteredContents  } = this.state;
      const finalcontent:any=[];
      filteredContents.forEach((res)=>{
        selectedContentsForDelete.forEach((data)=>{
          if(selectedContentType == "scheduledTests"){
          if(res.scheduleID == data){
            const newPackage={
              id:res.id,
              scheduleID:res.scheduleID
            }
            finalcontent.push(newPackage)
          }
        }else{
          if(res.id == data){
            const newPackage={
              id:res.id,
              scheduleID:res.scheduleID
            }
            finalcontent.push(newPackage)
          }
        }
        })
      })
      const finalpackages:any =[];
      filteredPackageList.forEach((res)=>{
        selectedPackage.forEach((data)=>{
          if(res._id == data){
            const newPackage={
              id:res._id,
              sku:res.sku
            }
            finalpackages.push(newPackage)
          }
        })
      })

      let payload = {
        courseId:selectedGoal._id,
        contentType:selectedContentType,
        content:finalcontent,
         packages:finalpackages
      }

      await courseManagementServices.deleteBulkContent(payload);
      this.props.closeBulkImport();
      this.props.redirectToBulkImport();
  }

  bulkMapProcess = async () => {
    const { selectedGoal, filteredPackageList,selectedContent,selectedContentType,selectedPackage,
    isBonus,minimumProficency,formData } = this.state;
    const finalpackages:any =[];
    filteredPackageList.forEach((res)=>{
      selectedPackage.forEach((data)=>{
        if(res._id == data){
          const newPackage={
            id:res._id,
            sku:res.sku
          }
          finalpackages.push(newPackage)
        }
      })
    })
   let payload:any={
    courseId:selectedGoal._id,
    contentType:selectedContentType,
    packages:finalpackages
   }
    if(selectedContentType ==='studyNotes' || selectedContentType ==='video'){
       payload = {
         ...payload,
        contentData:{
          "id": selectedContent.id,
          "description": selectedContent.description,
          "title": selectedContent.title,
          "type": selectedContentType,
          "contentId": selectedContent.contentId,
          "isBonus": isBonus,
          "bonusCriteria": [
            {
              "name": "proficiency",
              "value": minimumProficency
            }
          ]
        }
      }
      
    }
    else if(selectedContentType != 'scheduledTests'){
       payload = {
         ...payload,
        contentData:{
          "scheduleID": selectedContent.scheduleID,
          "title": selectedContent.title,
          "syllabus": selectedContent.syllabus,
          "startDate": selectedContent.startDate,
          "endDate": selectedContent.endDate,
          "revisionTime": selectedContent.revisionTime,
          "type": selectedContent.type,
          "duration": selectedContent.duration,
          "courseId": selectedContent.courseId,
          "contentId": selectedContent.contentId,
          "testType": selectedContent.testType,
          "id": selectedContent.id,
          "contentLevel": selectedContent.contentLevel,
          "isBonus": isBonus,
          "bonusCriteria": [
            {
              "name": "proficiency",
              "value": minimumProficency
            }
          ]
        }
      }
    }else{
      payload = {
        ...payload,
       contentData:{
         ...formData,
       }
     }
    }
    await courseManagementServices.updateBulkContent(payload);
    this.props.closeBulkImport();
    this.props.redirectToBulkImport();
  }

  testRenderer = () => {
    const { selectedTest, filteredTestList } = this.state;
    if (filteredTestList && filteredTestList.length > 0) {
      return (
        filteredTestList &&
        filteredTestList
          .reduce((acc: string[], curr) => {
            if (selectedTest.includes(curr._id)) {
              acc.push(curr.displayName);
            }
            return acc;
          }, [])
          .splice(0, 3)
          .join(", ")
      );
    }
    return [];
  };

  renderPrimaryTestOptions=()=>{
    const { selectedTest, filteredTestList,disabledPrimaryDropDown, primaryTest } = this.state;
    const options=[];
    if(!disabledPrimaryDropDown) {
    options.push(<option value={''}>{'Select Test'}</option>);
    filteredTestList.forEach((t, index) => {
      const { _id, displayName, scheduleID } = t;
      if(selectedTest.includes(_id)){
        options.push(
          <option key={index} value={_id}>
            {displayName}
          </option>
        );
       }
    });
  }else {
    options.push(<option value={primaryTest && primaryTest._id}>{primaryTest && primaryTest.displayName}</option>);

  }
    return options;
  }
  handleTestChange = (event: any) => {
    let eventId = event.target.value;
    let isChecked = event.target.checked;
    let { selectedTest, filteredTestList } = this.state;
    let newSelectedSubjects = [...selectedTest];

    if (isChecked) {
      if (eventId === "SelectAll") {
        newSelectedSubjects = [];
        filteredTestList.forEach((sub) => {
          newSelectedSubjects.push(sub._id);
        });
      } else {
        newSelectedSubjects.push(eventId);
      }
    } else {
      if (eventId === "SelectAll") {
        newSelectedSubjects = [];
      } else {
        let indx = newSelectedSubjects.indexOf(eventId);
        newSelectedSubjects.splice(indx, 1);
      }
    }

    this.setState({ selectedTest: newSelectedSubjects });
  };

  handleTestID=async (contentID:string)=>{
    const{selectedGoal}=this.state;
    // const primaryTest=await courseManagementService.validateMapTestId({testContentId:contentID, courseId:selectedGoal._id})
    // this.setState({inputTestId: contentID, primaryTest,disabledPrimaryDropDown:!_.isEmpty(primaryTest)}); 
  }
  handleExtraChange=(event:any)=>{
    const{name,value,checked}=event.target;
    const {formData} = this.state
  const newFormData={...formData,[name]:value};
    this.setState({
      formData:newFormData
    })
  }

  handleChange=(event:any)=>{
   const{name,value,checked}=event.target;
   const {selectedFields,allFields,formData,selectedContent}=this.state;
   let newFormData={...formData};
    if(name==="contentType"){
      this.setState({selectedContentType:value})
    }else if(name==="fields"){
       let newSelectedFields=[...selectedFields]
         if(checked){
          newSelectedFields.push(value);
        }
        else{
          let indx=newSelectedFields.indexOf(value);
          newSelectedFields.splice(indx,1);
          // @ts-ignore
          let keys = Object.keys(selectedFieldsMap).filter(x => selectedFieldsMap[x] == value);
          let key=_.get(keys,"[0]",null);
        if(key){  
            newFormData={...newFormData,[key]:selectedContent[key]};
          }
        }
       this.setState({selectedFields:newSelectedFields,formData:newFormData}); 
    }else if(name==="Tesame"){

    } 
  }
  renderer = (strArray?:string []) => {
    const { courseList } = this.props;
    const { selectedPackage } = this.state;
    if(strArray){
      return strArray.splice(0, 1).join(',');
    }
    if (courseList && courseList.length > 0) {
      let list: any[] = JSON.parse(JSON.stringify(courseList));
      return (
        list &&
        list
          .reduce((acc: string[], { _id, name }) => {
            if (selectedPackage.includes(_id)) {
              acc.push(name.split('|')[0])
            }
            return acc;
          }, []).splice(0, 3)
          .join(", ")
      );
    } else {
      return [];
    }
  };
  renderfeilds=(selected:any)=>{
    const { selectedFields,allFields } = this.state;
    if (selectedFields && selectedFields.length > 0) {
      let list: any[] = JSON.parse(JSON.stringify(allFields));
    return (
        list &&
        list
          .reduce((acc:any, curr) => {
             if (selectedFields.includes(curr)) {
              acc.push(curr);
            }
            return acc;
          }, []).splice(0, 3)
          .join(", ")
      );
    } else {
      return [];
    }
  }

  deleteContentRenderer() {
    const { selectedContentsForDelete } = this.state;
    let { packagesContent } = this.props;

    if (selectedContentsForDelete && selectedContentsForDelete.length > 0) {
      let list: any[] = JSON.parse(JSON.stringify(packagesContent));
    return (
        list &&
        list
          .reduce((acc:any, curr) => {
             if (selectedContentsForDelete.includes(this.state.selectedContentType == "scheduledTests"?curr.scheduleID:curr.id)) {
              acc.push(curr.title);
            }
            return acc;
          }, []).splice(0, 3)
          .join(", ")
      );
    } else {
      return [];
    }
  }
  handleCourseChange = (event: any) => {
    const subjectID = event.target.value;
    const isChecked = event.target.checked;
    let { selectedPackage, filteredPackageList } = this.state;
    let newSelectedSubjects = [...selectedPackage];
  
    if (isChecked) {
    if (subjectID === "SelectAll") {
        newSelectedSubjects = [];
        filteredPackageList.forEach((sub:any) => {
          if(!sub.isUpdateLocked){ 
            newSelectedSubjects.push(sub._id);
          }
        });
      } else {
        newSelectedSubjects.push(subjectID);
      }
    } else {
      if (subjectID === "SelectAll") {
        newSelectedSubjects = [];
      } else {
        let indx = newSelectedSubjects.indexOf(subjectID);
        newSelectedSubjects.splice(indx, 1);
      }
    }
    this.setState({ 
      selectedPackage : newSelectedSubjects,
      selectedContentType:''
        });
   };

   handleContentChangeDelete = (event: any) => {
    const contentId = event.target.value;
    const isChecked = event.target.checked;
    const { filteredContents, selectedContentsForDelete,selectedContentType } = this.state;
    let { packagesContent } = this.props;
    let newSelectedSubjects = [...selectedContentsForDelete];
    if (isChecked) {
    if (contentId === "SelectAll") {
        newSelectedSubjects = [];
        filteredContents.forEach((sub:any) => {
          if(selectedContentType == "scheduledTests"){
            newSelectedSubjects.push(sub.scheduleID)
          }else{
            newSelectedSubjects.push(sub.id)
          }
      });
      } else {
        newSelectedSubjects.push(contentId);
      }
    } else {
      if (contentId === "SelectAll") {
        newSelectedSubjects = [];
      } else {
        let indx = newSelectedSubjects.indexOf(contentId);
        newSelectedSubjects.splice(indx, 1);
      }
    }
    this.setState({ 
      selectedContentsForDelete : newSelectedSubjects
        });
   };
   getCourseSuggestions =(value: string)=> {
    const { courseList } = this.props;
    value = value.toString();
    value = value.replace(/[{()}]/g, '');
    value = value.replace(/\\|\//g,'')
    this.setState((prevState) => {
      let suggestions: any = [];
      if (value.length > 0) {
        value = value.toLowerCase();

        for (let indx = 0; indx < courseList.length; indx++) {
          let ug = courseList[indx];
         if (ug.name &&  ug.name.replace(/[{()}]/g, '').replace(/\\|\//g,'').toLocaleLowerCase().search(value) != -1) {
            suggestions.push(ug);
          }
        }
      } else {
        suggestions = [...courseList];
      }
      return { filteredPackageList: suggestions};
    });
  } 

  updateContent=()=>{
    this.setState({ openConfirmationPopup: true });
  }

  DeleteContent=()=>{
    this.setState({ openDeletePopup: true });
  }
  disableEditCta=()=>{
    if(this.state.selectedContentsForDelete.length<=0 || !this.state.selectedGoal || this.state.selectedPackage.length<=0||!this.state.selectedContentType
      ){
      return true
    }else{
      return false
    }
  }
  disabledCta=()=>{
    if(this.state.selectedContentsForDelete.length<=0 || !this.state.selectedGoal || this.state.selectedPackage.length<=0||!this.state.selectedContentType){
      return true
    }else{
      return false
    }
    
  }

  closeDeletePopup=()=>{
    this.setState({openDeletePopup : false });
  }
  changeBonus=()=>{
    const {isBonus} = this.state
     if(isBonus == true){
      this.setState({
        isBonus:!isBonus,
        minimumProficency:''
      })
    }else{
      this.setState({
        isBonus:!isBonus,
      })
    }
    
  }
  handleProficency=(data:any)=>{
    this.setState({
      minimumProficency:data
    })
  
  }

  onlyAllowNumbers = (evt: any, { allowNegative, currentValue } = { allowNegative: false, currentValue: '' }) => {
    var theEvent = evt
    var key = theEvent.keyCode || theEvent.which;
    key = String.fromCharCode(key);
    if(allowNegative) {
        if(key === '-' && !currentValue) {
            return;
        }
    }

    var regex = /[0-9]|\./;
    if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
    }
}
handleDateChange=(data:any,type:string)=>{
  const {formData}=this.state;
  const newFormData={...formData,[type]:data};
  this.setState({formData:newFormData});
// if(type==="startDate"){
//   this.setState({
//     startDate:data
//   })
// }else if(type==="endDate"){
//   this.setState({
//     endDate:data
//   })
// }
}
handleTimeChange = (time: any, type: string) => {
  const updatedcurrentTestDetail = { ...this.state.formData};
  const newTime = new Date(time);
  // console.log(newTime);
  const hours = newTime.getHours();
  const minutes = newTime.getMinutes();
  const seconds = newTime.getSeconds();
  const milliseconds = newTime.getMilliseconds();
  let { startDate, endDate } = updatedcurrentTestDetail;
  const minStartDate=_.get(this.props,"basicDetail.startDate.value");
  const minEndDate=_.get(this.props,"basicDetail.endDate.value");
  switch (type) {
    case 'startTime':
      // if(_.isEmpty(startDate)){
      //   startDate=minStartDate
      // }
      let tempDate = new Date(startDate);
      tempDate.setHours(hours, minutes, seconds, milliseconds);
      updatedcurrentTestDetail.startDate = tempDate.toISOString();
      //console.log({ tempDate, newTime });
      this.setState({
        formData:updatedcurrentTestDetail
      })
      break;
    case 'endTime':
      // if(_.isEmpty(endDate)){
      //   endDate=minEndDate;
      // }
      tempDate = new Date(endDate);
      tempDate.setHours(hours, minutes, seconds, milliseconds);
      updatedcurrentTestDetail.endDate = tempDate.toISOString();
      //console.log({ tempDate, newTime });
      this.setState({
        formData:updatedcurrentTestDetail
      })
      break;
    default:
  }

  this.setState({
    formData: updatedcurrentTestDetail,
  });
};
checkIsContentValid=():boolean=>{
  const{selectedContent,formData,selectedContentType,selectedFields}=this.state;
  if(_.isEmpty(selectedContent)){
    return false;
  }
 
  if(selectedContentType==='scheduledTests'){
    if(_.isEmpty(selectedFields)){
      return false;
    }
    let mandatoryKeys=['title','syllabus','startDate','endDate'];
    if(selectedContent.testType==='phase'){
      mandatoryKeys.push('maxAttempts');
    }
    if(selectedContent.id!==zero24){
      mandatoryKeys=[...mandatoryKeys,'duration','questionCount'];
    }
    for(let [key, value] of Object.entries(formData)){
      // @ts-ignore
     if(mandatoryKeys.includes(key) && selectedFields.includes(selectedFieldsMap[key])){
       if(key==='startDate' || key==='endDate'){
         if(value==''||value==null)
           return false
      }
      else if(!_.isInteger(value) && _.isEmpty(value)){
         console.log({key,value});
          return false;
      }
     }   
    }
  }
 return true; 
}
openCourse=()=>{
  const{ showPackageDropdown,selectedGoal} = this.state
  const { courseList } = this.props;
  if(selectedGoal.name !=''){
    this.setState((prevState) => ({
      ...prevState,
      showPackageDropdown: !prevState.showPackageDropdown,
      filteredPackageList: [...courseList],
    }));
  }
 }


  render() {
    const { classes, goals,courseList } = this.props;
    const {
      openConfirmationPopup,
      showSingleGoalDropdown,showSingleContentDropdown,
      filteredGoals,
      selectedGoal,
      isLoading,
      selectedTest,
      showPackageDropdown,showFieldsDropdown,
      selectedPackage, filteredPackageList,selectedContentType,
      selectedContent,filteredContents,allFields,selectedFields,
      selectedContentsForDelete,
      openDeletePopup,
      actionType,
      formData
    } = this.state;
    const {title,syllabus,startDate,endDate,questionCount,duration,maxAttempts,revisionTime}=formData;
    const typessss = this.state.selectedContentType === 'scheduledTests'?'Scheduled Test':this.state.selectedContentType === 'conceptTests'?'Concept Test':this.state.selectedContentType === 'chapterTests'?'Chapter Test':this.state.selectedContentType === 'studyNotes'?'Study Note':_.capitalize(this.state.selectedContentType);
    return (
      <>
        <MyPATDialog
          dialogOpen={true}
          dialogHasActions={true}
          dialogHeading={
            <>
              <h3 className={classes.bulkTitle}> Bulk Edit/Remove </h3>
            </>
          }
          isAlignCenter={true}
          customButtonVariant="withoutBorderCloseIcon"
          onDialogClose={this.props.closeBulkImport}
          isCustomBackground={false}
          isborderDialogAction={true}
          otherDialogProps={{
            fullWidth: false,
          }}
          customDialogActions={
            <>
              <Grid container justify="center">
                <Grid item>
                  {this.state.actionType == "edit" && (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => this.updateContent()}
                      disabled={!this.checkIsContentValid()}
                      //disabled={this.disableEditCta()}
                    >
                      Update
                    </Button>
                  )}
                  {this.state.actionType == "delete" && (
                    <Button
                      variant="contained"
                      color="primary"
                      disabled={this.disabledCta()}
                      onClick={() => this.DeleteContent()}
                    >
                      Delete
                    </Button>
                  )}
                </Grid>
              </Grid>
            </>
          }
        >
          <Grid container>
            <Grid style={{ marginTop: "-15px" }}>
              {this.handleRadio()}
            </Grid>
            <Grid item xs={12} className={classes.padding2x}>
              <Typography variant="h4" className={classes.courseTitle}>
                Select Target Exam{" "}
                <span className={classes.colorRed}>*</span>
              </Typography>
              <div className={classes.optionContainer}>
                <div
                  onClick={() => {
                    this.toggleGoalDropDown("goal");
                  }}
                >
                  <input
                    type="text"
                    placeholder="Search Target Exam"
                    value={selectedGoal.name}
                  />
                  <Grid className={classes.arrowIcon}>
                    {/* <KeyboardArrowDownIcon /> */}
                    <img src="/assets/svg/dropdown-arrow.svg" />
                  </Grid>
                </div>
                {showSingleGoalDropdown && (
                  <ClickAwayListener
                    onClickAway={() => {
                      this.toggleGoalDropDown("goal");
                    }}
                  >
                    <div className={classes.optionlistContainer}>
                      <div
                        className={[
                          classes.optionList,
                          classes.optionListEdit,
                        ].join(" ")}
                      >
                        <div className={classes.searchContainer}>
                          <input
                            type="text"
                            placeholder="Search Target Exam"
                            onChange={(event) => {
                              this.getFilteredGoals(event);
                            }}
                            name="goal"
                          />
                          <img src="/assets/svg/userManagement/search-icon.svg" />
                        </div>
                        {isLoading ? (
                          <span>Loading...</span>
                        ) : (
                          (filteredGoals || []).map((goal) => (
                            <span
                              key={goal._id}
                              onClick={() =>
                                this.setState({
                                  selectedGoal: goal,
                                  selectedPackage: [],
                                  selectedContent:{},
                                  selectedContentType:'',
                                  showSingleGoalDropdown: !showSingleGoalDropdown,
                                })
                              }
                            >
                              {goal.name}
                            </span>
                          ))
                        )}
                        {filteredGoals.length==0&&
                        <span>
                          No Goal Found
                          </span>
                        }
                      </div>
                    </div>
                  </ClickAwayListener>
                )}
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              className={cx(
                classes.padding2x,
                selectedGoal.name == '' ? classes.disabed : ""
              )}
            >
              <Typography variant="h4" className={classes.courseTitle}>
                Select Course<span className={classes.colorRed}>*</span>
              </Typography>
              <div 
               className={cx(
                classes.optionContainer,
              )}
              >
                <div
                  className={cx(classes.plusCourse)}
                  onClick={() => {
                  this.openCourse()
                  }}
                >
                  <input
                    type="text"
                    placeholder="Select Course Name or Course SKU"
                    value={this.renderer()}
                  />
                  {selectedPackage.length > 3 && (
                    <span>+{selectedPackage.length - 3}</span>
                  )}
                  <Grid className={classes.arrowIcon}>
                    {/* <KeyboardArrowDownIcon /> */}
                    <img src="/assets/svg/dropdown-arrow.svg" />
                  </Grid>
                </div>

                {showPackageDropdown && (
                  <ClickAwayListener
                    onClickAway={() => {
                      this.openCourse()
                    }}
                  >
                    <div className={classes.optionlistContainer}>
                      <div className={classes.optionList}>
                        <div className={classes.searchContainer}>
                          <input
                            type="text"
                            placeholder="Search Course"
                            onChange={(event) => {
                              this.getCourseSuggestions(event.target.value);
                            }}
                          />
                          <img src="/assets/svg/userManagement/search-icon.svg" />
                        </div>
                        {filteredPackageList.length > 0 && (
                          <span>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={
                                    filteredPackageList.length ==
                                    selectedPackage.length
                                  }
                                  onChange={this.handleCourseChange}
                                  name="Select All"
                                  color="primary"
                                />
                              }
                              label="Select All"
                              value="SelectAll"
                              key="select_all_course"
                            />
                          </span>
                        )}
                        {(filteredPackageList || []).map(
                          ({ _id, name,isUpdateLocked }) => (
                            <span>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={selectedPackage.includes(_id)}
                                    onChange={this.handleCourseChange}
                                    name="checkedB"
                                    color="primary"
                                    disabled={isUpdateLocked}
                                  />
                                }
                                label={name}
                                key={_id}
                                value={_id}
                              />
                            </span>
                          )
                        )}
                        {filteredPackageList.length==0&&
                        <span>
                          No Course Found
                          </span>
                        }
                      </div>
                    </div>
                  </ClickAwayListener>
                )}
              </div>
            </Grid>
            <Grid item xs={12} className={classes.padding2x}>
              <Grid className={classes.customSelect}>
                <Typography variant="h4" className={classes.courseTitle}>
                  Select Content Type{" "}
                  <span className={classes.colorRed}>*</span>
                </Typography>
                <MyPATSelect
                  value={selectedContentType || ""}
                  name="contentType"
                  onChange={(e: any) => this.handleChange(e)}
                  disabled={selectedPackage.length < 1}
                >
                  <option value="">{"Select Content Type"}</option>
                  {Object.keys(contentType).map((val: any) => {
                    return (
                      <option value={val}>
                        {
                          //@ts-ignore
                          contentType[val]
                        }
                      </option>
                    );
                  })}
                </MyPATSelect>
              </Grid>
            </Grid>

            <Grid item xs={12} className={classes.padding2x}>
              <Typography variant="h4" className={classes.courseTitle}>
                Select Content <span className={classes.colorRed}>*</span>
              </Typography>
              <div className={classes.optionContainer}>
                {actionType === "edit" && (
                  <div
                    onClick={() => {
                      this.toggleGoalDropDown("content");
                    }}
                  >
                    <input
                      type="text"
                      placeholder="Select A Content"
                      value={
                        (selectedContent &&
                          (selectedContent.name ||
                            selectedContent.title)) ||
                        ""
                      }
                    />
                    <Grid className={classes.arrowIcon}>
                      {/* <KeyboardArrowDownIcon /> */}
                      <img src="/assets/svg/dropdown-arrow.svg" />
                    </Grid>
                  </div>
                )}
                 {showSingleContentDropdown && actionType === "edit" && (
                  <>
                    <ClickAwayListener
                      onClickAway={() => {
                        this.toggleGoalDropDown("content");
                      }}
                    >
                      <div className={classes.optionlistContainer}>
                        <div
                          className={[
                            classes.optionList,
                            classes.optionListEdit,
                          ].join(" ")}
                        >
                          <div className={classes.searchContainer}>
                            <input
                              type="text"
                              placeholder="Search Content"
                              onChange={(event) => {
                                this.getFilteredContent(event);
                              }}
                              name="content"
                            />
                            <img src="/assets/svg/userManagement/search-icon.svg" />
                          </div>
                          {isLoading ? (
                            <span>Loading...</span>
                          ) : (
                            (filteredContents || []).map((c: any) => {
                              return(
                                <div className={classes.formula}>
                                  <div className={classes.plr15}>
                                    <span
                                      // key={}
                                      onClick={() =>
                                        this.setState({
                                          selectedContent: c,
                                          showSingleContentDropdown: !showSingleContentDropdown,
                                        })
                                      }
                                      dangerouslySetInnerHTML={{
                                        __html: ` ${
                                          _.get(c, "title", " ")} | 
                                        ${_.get(c,'contentId'," ")}`,
                                      }}
                                    >
                                    </span>
                                </div>
                                </div>
                              )}))  
                              }
                           {filteredContents.length==0&&
                        <span>
                          No Content Found
                          </span>
                        }
                        </div>
                      </div>
                    </ClickAwayListener>
                  </>
                )}
                {actionType !== "edit" && (
                  <div
                    className={cx(classes.plusCourse)}
                    onClick={() => {
                      this.toggleGoalDropDown("content");
                    }}
                  >
                    <input
                      type="text"
                      placeholder="Select A Content"
                      value={this.deleteContentRenderer()}
                    />
                    {selectedContentsForDelete.length > 3 && (
                      <span>+{selectedContentsForDelete.length - 3}</span>
                    )}
                    <Grid className={classes.arrowIcon}>
                      <img src="/assets/svg/dropdown-arrow.svg" alt="Select Content" />
                    </Grid>
                  </div>
                )}

                {showSingleContentDropdown && actionType !== "edit" && (
                  <>
                    <ClickAwayListener
                      onClickAway={() => {
                        this.toggleGoalDropDown("content");
                      }}
                    >
                      <div className={classes.optionlistContainer}>
                        <div
                          className={[
                            classes.optionList,
                            // classes.optionListEdit,
                          ].join(" ")}
                        >
                          <div className={classes.searchContainer}>
                            <input
                              type="text"
                              placeholder="Search Content"
                              name="content"
                              onChange={(event) => {
                                this.getFilteredContent(event);
                              }}
                            />
                            <img src="/assets/svg/userManagement/search-icon.svg" />
                          </div>
                          {filteredContents.length > 0 && (
                            <span>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={
                                      filteredContents.length ==
                                      selectedContentsForDelete.length
                                    }
                                    onChange={
                                      this.handleContentChangeDelete
                                    }
                                    name="Select All"
                                    color="primary"
                                  />
                                }
                                label="Select All"
                                value="SelectAll"
                                key="select_all_course"
                              />
                            </span>
                          )}
                          {(filteredContents || []).map(({ id, title,scheduleID,contentId }) => (
                            <div className={classes.formula}>
                              <div className={classes.plr15}>
                                <span>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={selectedContentsForDelete.includes(
                                          selectedContentType == "scheduledTests"?scheduleID:id
                                        )}
                                        onChange={
                                          this.handleContentChangeDelete
                                        }
                                        name="checkedB"
                                        color="primary"
                                      />
                                    }
                                    label={<div className={classes.contentTitle}>{title + " " +(contentId||"")}</div>}
                                    key={selectedContentType == "scheduledTests"?scheduleID:id}
                                    value={selectedContentType == "scheduledTests"?scheduleID:id}
                                  />
                                </span>
                              </div>
                            </div>
                          ))}
                           {filteredContents.length==0&&
                        <span>
                          No Content Found
                          </span>
                        }
                        </div>
                      </div>
                    </ClickAwayListener>
                  </>
                )}
              </div>
            </Grid>
            {selectedContentType == "scheduledTests" &&
              actionType == "edit" && (
                <Grid item xs={12} className={classes.padding2x}>
                  <Typography variant="h4" className={classes.courseTitle}>
                    Select Fields{" "}
                    <span className={classes.colorRed}>*</span>
                  </Typography>
                  <div className={classes.optionContainer}>
                    <div
                      className={cx(classes.plusCourse)}
                      onClick={() => {
                        this.setState({
                          showFieldsDropdown: !showFieldsDropdown,
                        });
                      }}
                    >
                      <input
                        type="text"
                        placeholder="Select Field(s)"
                        value={this.renderfeilds(selectedFields)}
                      />
                      {selectedFields.length > 3 && (
                        <span>+{selectedFields.length - 3}</span>
                      )}
                      <Grid className={classes.arrowIcon}>
                        {/* <KeyboardArrowDownIcon /> */}
                        <img src="/assets/svg/dropdown-arrow.svg" />
                      </Grid>
                    </div>

                    {showFieldsDropdown && (
                      <ClickAwayListener
                        onClickAway={() => {
                          this.toggleGoalDropDown("fields");
                        }}
                      >
                        <div className={classes.optionlistContainer}>
                          <div className={classes.optionList}>
                            {(allFields || []).map((f) => (
                              <span>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={selectedFields.includes(f)}
                                      onChange={this.handleChange}
                                      name="fields"
                                      color="primary"
                                      value={f}
                                    />
                                  }
                                  label={f}
                                  key={f}
                                  value={f}
                                />
                              </span>
                            ))}
                          </div>
                        </div>
                      </ClickAwayListener>
                    )}
                  </div>
                </Grid>
              )}
            {selectedContentType &&
              selectedContentType != "scheduledTests" && !_.isEmpty(selectedContent) &&
              actionType == "edit" && (
                <Grid container spacing={16} className={classes.padding2x} alignItems="center">
                  <Grid item xs={6}>
                    <Grid
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Grid>
                        <Typography style={{ fontSize: 13 }}>
                          Mark content as Bonus Content?&nbsp;
                        </Typography>
                      </Grid>
                      <Grid>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={this.state.isBonus}
                              onChange={this.changeBonus}
                              value="checkedB"
                              color="primary"
                            />
                          }
                          label=""
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={6}>
                    <Grid
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Grid>
                        <Typography>Minimum Proficiency</Typography>
                      </Grid>

                      <Grid className={classes.switchContainer}>
                        <MyPATTextField
                          name="value"
                          placeholder="Value (%)"
                          type={"number"}
                          disabled={!this.state.isBonus}
                          onChange={(e: ChangeEvent<HTMLInputElement>) => {
                            let value: string | number = e.target.value;
                            if (value) {
                              value =
                                parseInt(value) > 0 ? parseInt(value) : 1;
                              value =
                                value > 100
                                  ? this.state.minimumProficency
                                  : value;
                            }
                            this.handleProficency(value);
                          }}
                          onKeyPress={(e: any) => this.onlyAllowNumbers(e)}
                          value={this.state.minimumProficency}
                          fullWidthControl
                          endAdornment={<></>}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              )}
            {selectedFields.includes("Test Name") &&
              selectedContentType == "scheduledTests" &&
              actionType == "edit" && (
                <Grid container className={classes.padding2x} spacing={16}>
                  <Grid item xs={12} className={classes.padding2x}>
                    <Grid className={classes.customInput}>
                      <Typography className={classes.courseTitle}>
                        Test Name<span className={classes.colorRed}>*</span>
                      </Typography>
                      <TextField
                        id="outlined-bare0"
                        fullWidth={true}
                        margin="normal"
                        variant="outlined"
                        value={title}
                        name="title"
                        onChange={(e: any) => this.handleExtraChange(e)}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              )}
            {selectedFields.includes("Test Syllabus") &&
              selectedContentType == "scheduledTests" &&
              actionType == "edit" && (
                <Grid container spacing={16}>
                  <Grid item xs={12} className={classes.padding2x}>
                    <Grid className={classes.customInput}>
                      <Typography className={classes.courseTitle}>
                        Test Syllabus
                        <span className={classes.colorRed}>*</span>
                      </Typography>
                      <TextField
                        id="outlined-bare0"
                        fullWidth={true}
                        margin="normal"
                        variant="outlined"
                        value={syllabus}
                        name="syllabus"
                        onChange={(e: any) => this.handleExtraChange(e)}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              )}

            <>
              <Grid className={[classes.root, classes.padding2x].join(" ")}
              spacing={16}
              container>
                {selectedFields.includes("Start Date & Time") &&
                  selectedContentType == "scheduledTests" &&
                  actionType == "edit" && (
                    <>
                      <Grid
                        item
                        xs={6}
                        className={[
                          classes.customInput,
                          classes.textAreaEdit,
                        ].join(" ")}
                      >
                        <Typography className={classes.courseTitle}>
                          Start Date and Time
                          <span className={classes.colorRed}>*</span>
                        </Typography>
                        <MyPATCalendar
                          fullWidthControl
                          onChange={(dateVal: string) =>
                            this.handleDateChange(dateVal, "startDate")
                          }
                          date={startDate}
                          placeholder={"Start Date & Time"}
                          minDate={startDate}
                          //  maxDate={minEndDate}
                          errorText={"Start Date & Time does not lie within course duration"}
                        />
                      </Grid>
                      <Grid item xs={6}>
                      <div className={classes.customTime}>
                        {/* <Typography className={classes.courseTitle}>
                          End Date & Time
                        </Typography> */}

                        <TimeInput
                          mode="12h"
                          value={startDate ? new Date(startDate) : null}
                          onChange={(time: any) =>
                            this.handleTimeChange(time, "startTime")
                          }
                          disable={_.isEmpty(startDate)}
                          // defaultValue = {new Date()}
                          //placeholder={"Start Date & Time"}
                        />
                        </div>
                      </Grid>
                    </>
                  )}
                {selectedFields.includes("End Date & Time") &&
                  selectedContentType == "scheduledTests" &&
                  actionType == "edit" && (
                    <>
                      <Grid
                        item
                        xs={6}
                        className={[
                          classes.customInput,
                          classes.textAreaEdit,
                        ].join(" ")}
                      >
                        <Typography className={classes.courseTitle}>
                          End Date and Time
                          <span className={classes.colorRed}>*</span>
                        </Typography>
                        <MyPATCalendar
                          fullWidthControl
                          onChange={(dateVal: string) =>
                            this.handleDateChange(dateVal, "endDate")
                          }
                          date={endDate}
                          placeholder={"Select End Date & Time"}
                          minDate={startDate}
                           // maxDate={endDate}
                           errorText={"End Date & Time does not lie within course duration"}
                       
                        />
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        className={[
                          classes.customInput,
                          classes.textAreaEdit,
                          classes.calenderEdit,
                        ].join(" ")}
                      >
                        {/* <Typography className={classes.courseTitle}>
                          End Date & Time *
                        </Typography> */}
                        <div className={[classes.customTime, classes.customTimeEdit].join(' ')}>
                        <TimeInput
                          mode="12h"
                          value={endDate ? new Date(endDate) : null}
                          onChange={(time: any) =>
                            this.handleTimeChange(time, "endTime")
                          }
                          disable={_.isEmpty(endDate)}
                          // defaultValue = {new Date()}
                         // placeholder={"Select End Time"}
                        />
                        </div>
                      </Grid>
                    </>
                  )}
                {selectedFields.includes("Question Count") &&
                  selectedContentType == "scheduledTests" &&
                  actionType == "edit" && (
                    <Grid
                      item
                      xs={6}
                      className={[
                        classes.customInput,
                        classes.textAreaEdit,
                      ].join(" ")}
                    >
                      <Typography className={classes.courseTitle}>
                        Questions Count
                        <span className={classes.colorRed}>*</span>
                      </Typography>
                      <MyPATTextField
                        id="outlined-bare2"
                        fullWidth={true}
                        margin="normal"
                        variant="outlined"
                        name="questionCount"
                        value={questionCount}
                        //disabled={questionsCountFromAPI ? true : false }
                        onChange={(e: any) => this.handleExtraChange(e)}
                        onKeyPress={this.onlyAllowNumbers}
                      />
                    </Grid>
                  )}
                {selectedFields.includes("Duration") &&
                  selectedContentType == "scheduledTests" &&
                  actionType == "edit" && (
                    <Grid
                      item
                      xs={6}
                      className={[
                        classes.customInput,
                        classes.textAreaEdit,
                      ].join(" ")}
                    >
                      <Typography className={classes.courseTitle}>
                        Duration<span className={classes.colorRed}>*</span>
                      </Typography>
                      <MyPATTextField
                        id="outlined-bare1"
                        fullWidth={true}
                        margin="normal"
                        variant="outlined"
                        name="duration"
                        value={duration}
                        //  disabled={durationFromAPI ? true : false}
                        onChange={(e: any) => this.handleExtraChange(e)}
                        onKeyPress={this.onlyAllowNumbers}
                      />
                    </Grid>
                  )}
                {selectedFields.includes("Max Attempt") &&
                  selectedContentType == "scheduledTests" &&
                  actionType == "edit" && (
                    <Grid
                      item
                      xs={6}
                      className={[
                        classes.customInput,
                        classes.textAreaEdit,
                      ].join(" ")}
                    >
                      <Typography className={classes.courseTitle}>
                        Max Attempt
                        {selectedContent.testType === "phase" && (
                          <span className={classes.colorRed}>*</span>
                        )}
                      </Typography>
                      <MyPATTextField
                        id="outlined-bare2"
                        fullWidth={true}
                        margin="normal"
                        variant="outlined"
                        name="maxAttempts"
                        value={maxAttempts}
                        onChange={(e: any) => this.handleExtraChange(e)}
                        onKeyPress={this.onlyAllowNumbers}
                      />
                    </Grid>
                  )}
                {selectedFields.includes("Block Revision Time") &&
                  selectedContentType == "scheduledTests" &&
                  actionType == "edit" && (
                    <Grid
                      item
                      xs={6}
                      className={[
                        classes.customInput,
                        classes.textAreaEdit,
                      ].join(" ")}
                    >
                      <Typography className={classes.courseTitle}>
                        Block Revision Time For This Test
                      </Typography>
                      <MyPATTextField
                        fullwidth={true}
                        id="outlined-bare3"
                        fullWidth={true}
                        margin="normal"
                        variant="outlined"
                        name="revisionTime"
                        value={revisionTime}
                        onChange={(e: any) => this.handleExtraChange(e)}
                        onKeyPress={this.onlyAllowNumbers}
                      />
                      <span>(in Days)</span>
                    </Grid>
                  )}
              </Grid>
            </>
          </Grid>
        </MyPATDialog>
        {/* <Grid className={classes.noBorder}> */}
        <MyPATDialog
          dialogOpen={openConfirmationPopup}
          dialogHasActions={true}
          isAlignCenter={true}
          customButtonVariant="withoutBorderCloseIcon"
          onDialogClose={() => this.closeConfirmationDialog()}
          isCustomBackground={false}
          isborderDialogAction={true}
          otherDialogProps={{
            fullWidth: false,
          }}
          customDialogActions={
            <>
              <Grid
                container
                justify="center"
                style={{ paddingBottom: "30px" }}
              >
                <Grid item>
                  <Button
                    color="primary"
                    onClick={() => this.closeConfirmationDialog()}
                  >
                    No
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => this.bulkMapProcess()}
                  >
                    Yes
                  </Button>
                </Grid>
              </Grid>
              <br />
            </>
          }
        >
          <Grid className={classes.buttonCloseCont}>
            <MyPATIconButton
              className={classes.buttonClose}
              buttonVariant="flat"
              onClick={() => this.closeConfirmationDialog()}
            >
              <CloseIcon classes={{ root: classes.iconRoot }} />
            </MyPATIconButton>
          </Grid>
          <Grid container justify="center" style={{ textAlign: "center" }}>
            <Grid item>
              <img src="/assets/svg/edit-icon-2x.svg" />
              <h3>Update Scheduled Tests</h3>
              <Typography>
               <span style={{color: '#666666'}}> Are you sure, you want to update details of the {typessss} in</span>{" "}
                {this.state.selectedPackage.length} courses?
              </Typography>
            </Grid>
          </Grid>
        </MyPATDialog>
        <MyPATDialog
          dialogOpen={openDeletePopup}
          dialogHasActions={true}
          isAlignCenter={true}
          customButtonVariant="withoutBorderCloseIcon"
          onDialogClose={() => this.closeDeletePopup()}
          isCustomBackground={false}
          isborderDialogAction={true}
          otherDialogProps={{
            fullWidth: false,
          }}
          customDialogActions={
            <>
              <Grid
                container
                justify="center"
                style={{ paddingBottom: "30px" }}
              >
                <Grid item>
                  <Button
                    color="primary"
                    onClick={() => this.closeDeletePopup()}
                  >
                    No
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => this.DeleteProcess()}
                  >
                    Yes
                  </Button>
                </Grid>
              </Grid>
              <br />
            </>
          }
        >
          <Grid className={classes.buttonCloseCont}>
            <MyPATIconButton
              className={classes.buttonClose}
              buttonVariant="flat"
              onClick={() => this.closeDeletePopup()}
            >
              <CloseIcon classes={{ root: classes.iconRoot }} />
            </MyPATIconButton>
          </Grid>
          <Grid container justify="center" style={{ textAlign: "center" }}>
            <Grid item>
              <img src="/assets/svg/delete-icon.svg" />
              <h3>Remove Content</h3>
              <Typography>
                Are you sure, you want to Remove content{" "}
                {this.state.selectedContentsForDelete.length} items from{" "}
                {this.state.selectedPackage.length} courses?
              </Typography>
            </Grid>
          </Grid>
        </MyPATDialog>
        {/* </Grid> */}
      </>
    );
  }
}
const mapStateToProps = (state: any) => ({
  courseList: state.clientManagement.usersManagement.courseList,
  goals: state.courseMangementData.courseManagementReducer.activeGoals,
  scheduledTests:
    state.courseMangementData.courseManagementReducer.scheduledTests,
    packagesContent:state.courseMangementData.courseManagementReducer.packagesContent,
    isContentLoading:state.courseMangementData.courseManagementReducer.isContentLoading
});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      fetchScheduleTests: courseManagementActions.fetchScheduleTests,
      getActiveGoals: getActiveGoals,
      getCourseList,
      fetchContentFromPackages:courseManagementActions.fetchContentFromPackages
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(styles)(EditRemoveContent));
